/**
 * Extracts the path from a DISCO track URL.
 *
 * Validates if the URL belongs to a DISCO domain and returns just the path portion
 * if it does, or null otherwise. Also handles URL parsing errors safely.
 *
 * @param url - The URL to extract DISCO track path from
 * @returns The path part of a valid DISCO URL, null for non-DISCO URLs or parsing errors
 */
export const getDiscoTrackUrl = (url: string): string | null | undefined => {
  try {
    const { hostname, pathname } = new URL(url)
    const path = pathname.substring(1)

    if (
      hostname.endsWith('.disco.ac') ||
      hostname.includes('.disco-staging-')
    ) {
      return path
    } else {
      return null
    }
  } catch {
    return null
  }
}
